module.exports = __webpack_public_path__ + "img/hkqaa.afe84823.jpg";